/**
 * @generated SignedSource<<bf7406aa567fbba04e7cb02c4c87c8f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSwitchToLivePageSubTypeFragment$data = {
  readonly subType: string | null;
  readonly " $fragmentType": "useSwitchToLivePageSubTypeFragment";
};
export type useSwitchToLivePageSubTypeFragment$key = {
  readonly " $data"?: useSwitchToLivePageSubTypeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSwitchToLivePageSubTypeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useSwitchToLivePageSubTypeFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "Content"
};

(node as any).hash = "83901263f96d64a150282b24a00afaf6";

export default node;
